<template>
  <b-container>
    <b-form @submit="onSubmit" @reset="onReset">
      <div class="form-row">
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp1"
            label-cols="2"
            label="Scheme"
            label-size="sm"
            label-for="ipLoanType"
          >
            <b-select
              id="ipLoanType"
              class="form-control"
              value-field="LoanType"
              size="sm"
              text-field="SchemeName"
              :options="schemes"
              v-model="form.LoanType"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp2"
            label-cols="3"
            label="District"
            label-size="sm"
            label-for="ipDistrict"
          >
            <b-select
              id="ipDistrict"
              :options="districts"
              value-field="DistID"
              text-field="DistName"
              size="sm"
              :disabled="userDistrict != '00000000-0000-0000-0000-000000000000'"
              v-model="form.DistrictID"
              class="form-control"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp3"
            label-cols="2"
            label="Bank"
            label-size="sm"
            label-for="ipAPSts"
          >
            <b-select
              id="ipAPSts"
              class="form-control"
              :options="banks"
              value-field="BankID"
              text-field="BankName"
              required
              size="sm"
              v-model="form.BankID"
            ></b-select>
          </b-form-group>
        </b-col>
        <b-col class="mt-3" md="3">
          <b-form-group
            id="grp4"
            label-cols="4"
            label="Application No"
            label-size="sm"
            label-for="ipAppNum"
          >
            <b-form-input
              type="text"
              size="sm"
              id="ipAppNum"
              v-model="form.LoanApplicationNo"
            />
          </b-form-group>
        </b-col>
      </div>
      <b-row>
        <b-col class="mt-2" md="2">
          <b-form-group
            id="grp14"
            label-cols="3"
            label="LOI No"
            label-size="sm"
            label-for="ipLoiNum"
          >
            <b-form-input
              type="text"
              size="sm"
              id="ipLoiNum"
              v-model="form.LOINumber"
            />
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="3">
          <b-form-group
            id="grp13"
            label-cols="4"
            label="Upload Date"
            label-size="sm"
            label-for="ipAPDt"
          >
            <date-picker
              v-model="UpdateDate"
              format="DD-MM-YYYY"
              id="ipAPDt"
              lang="en"
              range
              size="small"
              style="width: 220px"
            ></date-picker>
          </b-form-group>
        </b-col>
        <b-col class="mt-2" md="3">
          <!-- <b-form-group
            id="grp2"
            label-cols="3"
            label="Claim Status"
            label-size="sm"
            label-for="ipDistrict"
          >
            <b-select
              id="ipDistrict"
              :options="approvalStatus"
              value-field="Id"
              text-field="ApplicationStatus"
              size="sm"
              v-model="form.ClaimStatus"
              class="form-control"
            ></b-select>
          </b-form-group>-->
        </b-col>
        <b-col class="mt-0" md="3">
          <b-button type="submit" size="sm" variant="primary" class="my-2"
            >Search</b-button
          >
          <b-button type="reset" size="sm" variant="secondary" class="my-2"
            >Reset</b-button
          >
        </b-col>
      </b-row>
    </b-form>
    <hr />

    <b-row class="mb-2">
      <b-col md="4">
        <b-input-group>
          <b-form-input
            v-model="filter"
            placeholder="Type to Search"
            size="sm"
          />
          <b-input-group-append>
            <b-btn :disabled="!filter" @click="filter = ''" size="sm"
              >Clear</b-btn
            >
          </b-input-group-append>
        </b-input-group>
      </b-col>
      <b-col></b-col>
      <b-col md="4">
        <b-form-group
          horizontal
          label="Sort"
          class="mb-0"
          label-size="sm"
          label-cols="1"
        >
          <b-input-group>
            <b-form-select v-model="sortBy" :options="sortOptions" size="sm">
              <option slot="first" :value="null">-- none --</option>
            </b-form-select>
            <b-input-group-append>
              <b-form-select :disabled="!sortBy" v-model="sortDesc" size="sm">
                <option :value="false">Asc</option>
                <option :value="true">Desc</option>
              </b-form-select>
            </b-input-group-append>
          </b-input-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-container style="overflow-x: auto">
      <b-table
        show-empty
        selectable
        responsive="true"
        select-mode="single"
        head-variant="dark"
        empty-text="No Disbursal available."
        stacked="md"
        bordered
        striped
        :items="claims"
        :fields="fields"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        @filtered="onFiltered"
        @row-selected="onRowSelected"
        style="font-size: 12px"
      >
        <template v-slot:cell(action)="row">
          <a target="_blank" :href="getImgUrl(row.item)">View</a>
          <b-btn variant="link" size="sm" @click.stop="changeDoc(row.item)"
            >Change</b-btn
          >
        </template>
        <template v-slot:cell(edit)="row">
          <b-btn variant="link" size="sm" @click.stop="editLoan(row.item)"
            >Edit</b-btn
          >
        </template>
      </b-table>
    </b-container>
    <b-row>
      <b-col md="8" class="my-1">
        <b-pagination
          :total-rows="totalRows"
          :per-page="perPage"
          v-model="currentPage"
          class="my-0"
          size="sm"
        />
      </b-col>
      <b-col md="4" class="my-1">
        <b-form-group
          horizontal
          label="Per page"
          class="mb-0"
          label-size="sm"
          :label-cols="6"
        >
          <b-form-select :options="pageOptions" v-model="perPage" size="sm" />
        </b-form-group>
      </b-col>
    </b-row>
    <b-modal
      id="modalDoc"
      size="xl"
      title="Claim Details"
      scrollable
      hide-footer
    >
      <document-upload
        :UserID="selectedLoginID"
        :Stage="stage"
        :Id="selectedId"
      ></document-upload>
    </b-modal>
    <b-modal id="modalEdit" size="xl" title="Edit Loan" scrollable hide-footer>
      <edit-loan-details :item="selectedItem"></edit-loan-details>
    </b-modal>
  </b-container>
</template>

<script>
import apis from "@/apis";
import { mapState } from "vuex";
import lambda from "@/apis/lambda";
import { detectTenant, filterByCaste } from "@/tenantConfig";
import * as _ from "lodash";
import axios from "axios";
import Formatter from "@/Formatter";
import Spinner from "vue-simple-spinner";
import DatePicker from "vue2-datepicker";
import DocumentUpload from "@/components/ClaimApproval/DocumentUpload";
import EditLoanDetails from "./EditLoanDetails.vue";

export default {
  components: { Spinner, DatePicker, DocumentUpload, EditLoanDetails },
  data() {
    return {
      show: false,
      showsts: false,
      modalInfo: "",
      UpdateDate: [null, null],
      districts: [],
      schemes: [],
      approvalStatus: [],
      paymentStatus: [],
      claims: [],
      bscReport: "",
      bscReportPath: "",
      banks: [],
      fields: [
        { key: "FullName", label: "Full Name", sortable: true },
        { key: "AdharNo", label: "Aadhar" },
        { key: "LoanBank", label: "Loan Bank", sortable: true },
        { key: "LoanBranch", label: "Loan Branch", sortable: true },
        { key: "LoanApplicationNo", label: "Application No", sortable: true },
        { key: "SanctionAmount", label: "Sanction Amount", sortable: true },
        { key: "DisburmentAmount", label: "Disbursed Amount", sortable: true },
        {
          key: "DisbursalDate",
          label: "Disbursal Date",
          sortable: true,
          formatter: "convertDateFormat",
        },
        { key: "TrancheNo", label: "Tranche No", sortable: true },
        { key: "TotalDisbursal", label: "Total Disbursal", sortable: true },
        { key: "EmiAmount", label: "EMI Amount", sortable: true },
        { key: "ROI", label: "ROI%", sortable: true },
        { key: "LoanTenure", label: "Tenure (months)", sortable: true },
        {
          key: "EmiStartDate",
          label: "EMI Start Date",
          sortable: true,
          formatter: "convertDateFormat",
        },
        {
          key: "EmiEndDate",
          label: "EMI End Date",
          sortable: true,
          formatter: "convertDateFormat",
        },
        { key: "TotalEMIPaid", label: "EMI Paid Amt", sortable: true },
        {
          key: "TotalClaimAmount",
          label: "Total Claim Amount",
          sortable: true,
        },
        { key: "TotalPaidClaim", label: "Total Paid Claim", sortable: true },
        { key: "action", label: "Disb. Letter" },
        { key: "edit", label: "Edit" },
      ],
      selected: [],
      form: {
        DistrictID: "00000000-0000-0000-0000-000000000000",
        BankID: "00000000-0000-0000-0000-000000000000",
        LoanApplicationNo: "",
        LOINumber: "",
        UserLoginID: "00000000-0000-0000-0000-000000000000",
        DisbursementStartDate: null,
        DisbursementEndDate: null,
        LoanType: 1,
      },
      formclm: {
        ClaimStatusID: 1,
        RejectReason: 0,
        Remarks: "",
        UserID: "",
        ClaimID: "",
      },
      RoleID: 0,
      selectedApplication: "",
      currentPage: 1,
      perPage: 10,
      totalRows: 0,
      pageOptions: [5, 10, 15, 30, 60],
      sortBy: null,
      sortDesc: false,
      filter: null,
      showDismissibleAlert: false,
      variant: "success",
      alertText: "",
      isLoading: false,
      LoanDetails: {
        BankName: "--",
        BranchName: "--",
        ApprovedAmount: 0,
        DisbursementAmount: 0,
        ROI: 0,
        Tenure: 0,
      },
      stage: 3,
      selectedLoginID: "00000000-0000-0000-0000-000000000000",
      selectedId: "00000000-0000-0000-0000-000000000000",
      selectedItem: {},
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter((f) => f.sortable)
        .map((f) => {
          return { text: f.label, value: f.key };
        });
    },
    userDistrict() {
      return this.$store.getters.getUserDistrict;
    },
  },
  methods: {
    editLoan(item) {
      this.selectedItem = item;
      this.$root.$emit("bv::show::modal", "modalEdit");
    },
    changeDoc(item) {
      this.selectedLoginID = item.UserID;
      this.selectedId = item.LoanDisbursementID;
      this.$root.$emit("bv::show::modal", "modalDoc");
    },
    convertDateFormat(inDate) {
      return Formatter.convertDateFormat(inDate);
    },
    getImgUrl(pic) {
      if (pic) {
        return (
          "https://aws.msobcfdc.in/S3BucketApril/" +
          pic.UserID +
          "/" +
          pic.UploadDisburmentLetter
        );
      }
    },
    onRowSelected(items) {
      this.selected = items;
    },
    selectAllRows() {
      this.$refs.selectableTable.selectAllRows();
    },
    clearSelected() {
      this.$refs.selectableTable.clearSelected();
    },
    deleteDocument(item, index, button) {
      //console.log(item);
      this.selecteObj.Document = item.Document;
      this.selecteObj.Path = item.Path;

      let info = "You want to delete record for:" + "\n" + item.Document;
      this.modalInfo = info;
      this.$root.$emit("bv::show::modal", "modalConfirm");
    },
    modalCancel() {
      this.selecteObj.Document = "";
      this.selecteObj.Path = "";
      this.$root.$emit("bv::hide::modal", "modalConfirm");
    },

    modalConfirm() {
      this.form.UserLoanDocuments[this.selecteObj.Document] = "";

      var userinfo = this.$store.getters.loggedUser;
      var LoginID = userinfo.UserId;
      //   var filename =   this.Photo.name;
      this.form.LoginID = LoginID;
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    getDistricts(stateid) {
      let promise = apis.getDistricts(stateid);

      promise
        .then((response) => {
          if (response.status == 200) {
            this.districts = response.body;
            this.districts.unshift({
              DistID: "00000000-0000-0000-0000-000000000000",
              DistName: "All",
            });

            this.form.DistrictID = this.$store.getters.getDistrict;
            this.isLoading = false;
            //this.$router.push("/");
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    ReadBanks() {
      let promise = apis.ReadBankMaster();

      promise
        .then((response) => {
          //console.log('Physical Response' ,response);
          if (response.status == 200) {
            this.banks = response.body;
            this.banks.unshift({
              BankID: "00000000-0000-0000-0000-000000000000",
              BankName: "All",
            });
            this.isLoading = false;
          } else {
            this.alertText = response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
        });
    },
    getSchemes() {
      let promise = apis.getSchemes();

      promise
        .then((response) => {
          if (response.status == 200) {
            //let rspns = response.body;
            //this.$store.dispatch("setSchemeList", rspns);
            this.schemes = response.body;
            this.form.LoanType = this.$store.getters.getLoanType;
          } else {
            this.alertText = "Unable to Load Scheme List, " + response.body;

            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = "Unable to Load Scheme List, " + err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.getDisbursals();
    },

    getDisbursals() {
      this.isLoading = true;
      this.showDismissibleAlert = false;
      if (this.UpdateDate != null) {
        this.form.DisbursementStartDate = Formatter.convertDateFormatYMD(
          this.UpdateDate[0]
        );
        this.form.DisbursementEndDate = Formatter.convertDateFormatYMD(
          this.UpdateDate[1]
        );
      } else {
        this.form.DisbursementStartDate = null;
        this.form.DisbursementEndDate = null;
      }

      //let promise = apis.readAllClaims(this.form);
      let promise = apis.ReadDisbursementByQuery(this.form);

      promise
        .then((response) => {
          //console.log(response);
          if (response.status == 200) {
            this.claims = filterByCaste(response.body, detectTenant());
            this.totalRows = this.claims.length;
          } else {
            this.alertText = response.body;
            this.variant = "warning";
            this.showDismissibleAlert = true;
          }
          this.isLoading = false;
        })
        .catch((err) => {
          this.alertText = err.message;
          this.showDismissibleAlert = true;
          this.variant = "danger";
          this.isLoading = false;
        });

      //console.log(this.selectedDistrict);
    },
    onReset(evt) {
      evt.preventDefault();
      this.form = {
        DistrictID: "",
        LoanType: 1,
        MobileNo: "",
        ApplicationNo: "",
      };
    },
    //ReadClaimRejectionReason
  },
  created() {
    var dt = new Date();
    var dtInMs = dt.getTime();
    dtInMs -= 60 * 1000 * 60 * 24 * 30; //30 Days
    dt.setTime(dtInMs);

    this.UpdateDate[0] = dt;
    this.UpdateDate[1] = new Date();
  },
  mounted() {
    //this.getDisbursals();
    this.form.DistrictID = this.$store.getters.getUserDistrict;
    this.getDistricts("BB62F7B0-748D-4E64-AD4F-8EF691431FA1");
    this.getSchemes();
    this.ReadBanks();

    var userinfo = this.$store.getters.loggedUser;
    this.RoleID = userinfo.RoleID;
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/ClaimApproval/DisbursalList.vue